import React, { FC } from 'react';
import { t } from '../../../../../../utils/helpers';

type PropsType = {
  info: {
    directorName: string;
    directorId: string;
    startTime: string;
    pairing: string;
    timeControl: string;
    entryFee: number;
    description: string;
    extraBonus: string;
  };
};

export const FinishedTournamentInfo: FC<PropsType> = ({ info }: PropsType) => {
  return (
    <div className="finished-additional__info">
      <div className="finished-additional__info-item">
        <div className="finished-additional__info-title">{t('director')}</div>
        <div className="finished-additional__info-description finished-additional__info-name">
          <img
            className="finished-additional__img"
            src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${info.directorId}&size=2`}
            alt="avatar"
          />
          {info.directorName}
        </div>
      </div>

      <div className="finished-additional__info-item">
        <div className="finished-additional__info-title">{t('start_time')}</div>
        <div className="finished-additional__info-description">
          {info.startTime}
        </div>
      </div>

      <div className="finished-additional__info-item">
        <div className="finished-additional__info-title">{t('pairing')}</div>
        <div className="finished-additional__info-description">
          {info.pairing === '1'
            ? t('single_elim')
            : info.pairing === '2'
            ? t('double_elim')
            : info.pairing === '3'
            ? t('swiss')
            : null}
        </div>
      </div>

      <div className="finished-additional__info-item">
        <div className="finished-additional__info-title">
          {t('time_control')}
        </div>
        <div className="finished-additional__info-description">
          {info.timeControl}
        </div>
      </div>

      <div className="finished-additional__info-item">
        <div className="finished-additional__info-title">{t('entry_fee')}</div>
        <div className="finished-additional__info-description">
          {info.entryFee}
        </div>
      </div>

      <div className="finished-additional__info-item">
        <div className="finished-additional__info-title">
          {t('description')}
        </div>
        <div className="finished-additional__info-description">
          {info.description}
        </div>
      </div>

      {info.extraBonus !== '0.00' ? (
        <div className="finished-additional__info-item">
          <div className="finished-additional__info-title">
            {t('extra_bonus')}
          </div>
          <div className="finished-additional__info-description">
            {info.extraBonus}
          </div>
        </div>
      ) : null}
    </div>
  );
};
